import { ApplicationConfig, ErrorHandler, LOCALE_ID, inject, isDevMode, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateLoader, TranslateService, provideTranslateService } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideOktaAuth, withOktaConfig } from '@okta/okta-angular';
import { environment } from '../environments/environment';
import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { authInterceptor } from './app-core/interceptors/auth.interceptor';
import { errorCatchingInterceptor } from './app-core/interceptors/error-catching.interceptor';
import { loadingInterceptor } from './app-core/interceptors/loading.interceptor';
import { ErrorReporter } from './app-core/services/error-reporter';
import { OktaAuth } from '@okta/okta-auth-js';
import localePl from '@angular/common/locales/pl';

const DEFAULT_LANG = localStorage.getItem('language') || 'pl-PL';

registerLocaleData(localePl);
const oktaAuth = new OktaAuth(environment.okta);
export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      translate.setFallbackLang(DEFAULT_LANG);
      return translate.use(DEFAULT_LANG);
    }),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([
      authInterceptor,
      loadingInterceptor,
      errorCatchingInterceptor,
    ])),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: () => new TranslateHttpLoader(),
      }
    }),
    provideOktaAuth(
      withOktaConfig({ oktaAuth })
    ),
    provideRouter(routes, withComponentInputBinding(), withViewTransitions()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    {
      provide: ErrorHandler,
      useClass: ErrorReporter,
    },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'yyyy-MM-dd' }
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'pl-PL'
    },
    {
      provide: LOCALE_ID, useValue: 'pl-PL'
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' }
    },
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: { prefix: `i18n/` },
    },
  ]
};
